import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { upsertMeta, removeMeta } from '@/utils/headTags';

export function NotFound() {
  // La pagina risponde comunque HTTP 200 (SPA senza server-side rendering) —
  // senza noindex Google potrebbe indicizzare per errore URL rotti come se
  // fossero contenuto reale.
  useEffect(() => {
    upsertMeta('name', 'robots', 'noindex, nofollow');
    return () => removeMeta('name', 'robots');
  }, []);

  return (
    <section className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 py-32">
      <p className="text-body-sm tracking-widest uppercase text-theme-text-muted mb-4">404</p>
      <h1 className="font-heading text-h1 font-light mb-5 text-theme-text">Pagina non trovata</h1>
      <p className="text-body-lg text-theme-text-muted mb-9 max-w-md">
        La pagina che cerchi non esiste o è stata spostata.
      </p>
      <Link
        to="/"
        className="inline-flex items-center px-8 py-3.5 rounded-lg bg-theme-accent text-theme-accent-text text-sm font-medium tracking-wide"
      >
        Torna alla home
      </Link>
    </section>
  );
}
